import { useEffect, useState } from 'react';

import {
  CampoLocalizacao,
  carregarCamposLocalizacao
} from '../utils/InscricaoCadastralUtils';

/**
 * Campos de localização do imóvel urbano, conforme a parametrização de
 * Tributos > Configurações > Inscrição Cadastral.
 *
 * Quando a tela já carregou a configuração, basta repassar os campos em
 * `camposInformados` — nesse caso não há nova requisição.
 */
export const useCamposLocalizacao = (
  camposInformados?: CampoLocalizacao[]
): CampoLocalizacao[] => {
  const [camposCarregados, setCamposCarregados] = useState<CampoLocalizacao[]>(
    []
  );
  const deveCarregar = camposInformados === undefined;

  useEffect(() => {
    if (!deveCarregar) {
      return;
    }

    let ativo = true;
    carregarCamposLocalizacao().then(campos => {
      if (ativo) {
        setCamposCarregados(campos);
      }
    });

    return () => {
      ativo = false;
    };
  }, [deveCarregar]);

  return camposInformados ?? camposCarregados;
};
